/* ============================================================
   SAGES OF THE AGES — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ===================== MOBILE MENU ===================== */
  const hamburger = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-overlay');
  const closeBtn = document.getElementById('mobile-close');

  function openMenu() {
    hamburger?.classList.add('open');
    mobileMenu?.classList.add('open');
    overlay?.classList.add('open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    hamburger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    hamburger?.classList.remove('open');
    mobileMenu?.classList.remove('open');
    overlay?.classList.remove('open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    hamburger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', () => {
    if (mobileMenu?.classList.contains('open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  closeBtn?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  /* ===================== STICKY HEADER SHADOW ===================== */
  const header = document.getElementById('site-header');
  let lastScroll = 0;

  function handleScroll() {
    const currentScroll = window.scrollY;
    if (currentScroll > 80) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Add scrolled style dynamically
  const scrollStyle = document.createElement('style');
  scrollStyle.textContent = `
    .site-header.scrolled { box-shadow: 0 2px 20px rgba(0,0,0,0.1); }
  `;
  document.head.appendChild(scrollStyle);

  /* ===================== PRODUCTS SLIDER ===================== */
  const slider = document.getElementById('products-slider');
  const prevBtn = document.getElementById('products-prev');
  const nextBtn = document.getElementById('products-next');

  function getScrollAmount() {
    const card = slider?.querySelector('.product-card');
    if (!card) return 280;
    return card.offsetWidth + 20;
  }

  prevBtn?.addEventListener('click', () => {
    slider?.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
  });

  nextBtn?.addEventListener('click', () => {
    slider?.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
  });

  // Touch/drag scroll support for the slider
  if (slider) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  /* ===================== INLINE VIDEO REVIEWS ===================== */
  function initVideoPlayBtns() {
    document.querySelectorAll('.video-play-btn').forEach((btn) => {
      if (btn._vrVideoInited) return; // prevent double-binding
      btn._vrVideoInited = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const wrap = btn.closest('.video-thumb-wrap');
        const videoUrl = btn.getAttribute('data-video-url');
        if (!wrap || !videoUrl) return;
        if (wrap.querySelector('video')) return;
        btn.style.display = 'none';
        const videoEl = document.createElement('video');
        videoEl.src = videoUrl;
        videoEl.controls = true;
        videoEl.autoplay = true;
        videoEl.loop = false;
        videoEl.className = 'inline-video-player';
        videoEl.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;z-index:5;border-radius:12px;';
        wrap.appendChild(videoEl);
        document.querySelectorAll('.inline-video-player').forEach(v => { if (v !== videoEl) v.pause(); });
        videoEl.play().catch(() => { });
      });
    });
  }
  initVideoPlayBtns();

  /* ===================== VIDEO REVIEWS SLIDER ===================== */
  (function () {
    const track = document.getElementById('vr-slider-track');
    const prevBtn = document.getElementById('vr-prev');
    const nextBtn = document.getElementById('vr-next');
    const dotsWrap = document.getElementById('vr-slider-dots');

    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.vr-slide'));
    if (!slides.length) return;

    let currentIndex = 0;

    function getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 768) return 1;
      if (w <= 1024) return 2;
      return 4;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const total = slides.length - getVisibleCount() + 1;
      for (let i = 0; i < Math.max(total, 1); i++) {
        const dot = document.createElement('button');
        dot.className = 'vr-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.vr-dot').forEach((d, i) => {
        d.classList.toggle('active', i === currentIndex);
      });
    }

    function updateArrows() {
      const maxIndex = Math.max(0, slides.length - getVisibleCount());
      if (prevBtn) prevBtn.classList.toggle('vr-disabled', currentIndex <= 0);
      if (nextBtn) nextBtn.classList.toggle('vr-disabled', currentIndex >= maxIndex);
    }

    function getSlideWidth() {
      return slides[0] ? slides[0].offsetWidth + 20 : 0; // 20 = gap
    }

    function goTo(index) {
      const maxIndex = Math.max(0, slides.length - getVisibleCount());
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      track.style.transform = 'translateX(-' + (currentIndex * getSlideWidth()) + 'px)';
      updateDots();
      updateArrows();
    }

    prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
    nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

    // Keyboard support
    document.addEventListener('keydown', (e) => {
      if (!document.getElementById('reviews')?.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
      if (e.key === 'ArrowRight') goTo(currentIndex + 1);
    });

    // Mouse Drag & Touch/swipe support
    let startX = 0;
    let isMouseDown = false;
    let isDragging = false;
    const viewport = track.parentElement || track;
    viewport.style.cursor = 'grab';
    function onStart(e) {
      isMouseDown = true;
      isDragging = false;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      if (!e.touches) viewport.style.cursor = 'grabbing';
    }
    function onMove(e) {
      if (!isMouseDown) return;
      const currentX = e.touches ? e.touches[0].clientX : e.clientX;
      const diff = startX - currentX;
      if (Math.abs(diff) > 10) isDragging = true;
    }
    function onEnd(e) {
      if (!isMouseDown) return;
      isMouseDown = false;
      if (!e.touches) viewport.style.cursor = 'grab';
      const currentX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      const diff = startX - currentX;
      if (Math.abs(diff) > 40) {
        goTo(currentIndex + (diff > 0 ? 1 : -1));
      }
      setTimeout(() => { isDragging = false; }, 100);
    }
    viewport.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);
    viewport.addEventListener('touchstart', onStart, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: true });
    viewport.addEventListener('touchend', onEnd);

    // On resize: rebuild dots, re-clamp index
    window.addEventListener('resize', () => {
      buildDots();
      goTo(currentIndex);
    });

    // Init
    buildDots();
    goTo(0);
  })();

  /* ===================== CART DRAWER ===================== */
  window.CartDrawer = {
    init: function () {
      this.getElements();
      this.bindEvents();
    },

    getElements: function() {
      this.drawer = document.getElementById('CartDrawer');
      this.overlay = document.getElementById('CartDrawerOverlay');
      this.closeBtn = document.getElementById('CartDrawerClose');
      this.content = document.getElementById('CartDrawerContent');
    },

    bindEvents: function () {
      // Delegate click for cart icon and drawer contents (handles dynamic headers and re-rendering)
      document.addEventListener('click', (e) => {
        // Close buttons
        if (e.target.closest('#CartDrawerClose') || e.target.id === 'CartDrawerOverlay') {
          this.close();
          return;
        }

        // Cart icon
        const cartIcon = e.target.closest('.cart-icon');
        if (cartIcon) {
          e.preventDefault();
          this.open();
          return;
        }

        // Drawer clicks
        if (e.target.closest('.cart-drawer__content')) {
          this.handleClicks(e);
        }
      });

      document.addEventListener('change', (e) => {
        if (e.target.closest('.cart-drawer__content')) {
          this.handleChange(e);
        }
      });
    },

    open: function () {
      this.getElements();
      
      if (!this.drawer) {
        // Fallback: If {% section 'cart-drawer' %} wasn't added to theme.liquid,
        // dynamically fetch the section from Shopify's servers!
        fetch('/?section_id=cart-drawer')
          .then(res => res.text())
          .then(text => {
            if (text && !text.includes('Liquid error')) {
              const temp = document.createElement('div');
              temp.innerHTML = text;
              
              // Extract the actual drawer and overlay
              const newOverlay = temp.querySelector('.cart-drawer-overlay');
              const newDrawer = temp.querySelector('.cart-drawer');
              
              if (newOverlay) document.body.appendChild(newOverlay);
              if (newDrawer) document.body.appendChild(newDrawer);
              
              // Now that it's in the DOM, open it!
              this.getElements();
              if (this.drawer) {
                this.drawer.classList.add('is-active');
                this.drawer.style.right = '0';
              }
              if (this.overlay) {
                this.overlay.classList.add('is-active');
                this.overlay.style.opacity = '1';
                this.overlay.style.visibility = 'visible';
              }
              document.body.style.overflow = 'hidden';
            } else {
              alert("Cart Drawer section could not be loaded from Shopify servers.");
            }
          })
          .catch(err => {
            console.error('Failed to load cart drawer dynamically', err);
            alert("Error loading cart drawer.");
          });
        return;
      }

      this.drawer.classList.add('is-active');
      if (this.overlay) this.overlay.classList.add('is-active');
      
      // Force inline styles as a fallback in case CSS is cached/failing
      this.drawer.style.right = '0';
      if (this.overlay) {
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
      }
      
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      this.getElements();
      if (this.drawer) {
        this.drawer.classList.remove('is-active');
        this.drawer.style.right = '-100%';
      }
      if (this.overlay) {
        this.overlay.classList.remove('is-active');
        this.overlay.style.opacity = '0';
        this.overlay.style.visibility = 'hidden';
      }
      document.body.style.overflow = '';
    },

    handleClicks: function (e) {
      // Remove item
      const removeBtn = e.target.closest('.cart-drawer__remove-btn');
      if (removeBtn) {
        e.preventDefault();
        this.updateItem(removeBtn.dataset.key, 0);
        return;
      }

      // Qty plus/minus
      const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        const isPlus = qtyBtn.classList.contains('plus');
        const input = qtyBtn.parentElement.querySelector('.cart-drawer__qty-input');
        if (input) {
          let val = parseInt(input.value);
          if (isNaN(val)) val = 1;
          val = isPlus ? val + 1 : Math.max(0, val - 1);
          input.value = val;
          this.updateItem(input.dataset.key, val);
        }
        return;
      }

      // Upsell Add To Cart
      const upsellBtn = e.target.closest('.cart-drawer__upsell-btn');
      if (upsellBtn) {
        e.preventDefault();
        const variantId = upsellBtn.dataset.variantId;
        if (variantId) {
          upsellBtn.disabled = true;
          upsellBtn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(() => {
              this.updateHeaderCartCount();
              this.refresh();
            })
            .catch(err => {
              console.error(err);
              upsellBtn.disabled = false;
              upsellBtn.textContent = 'Error';
            });
        }
      }
    },

    handleChange: function (e) {
      if (e.target.id === 'CartDrawerGiftNote') {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { gift_note: e.target.checked } })
        });
      }
    },

    updateItem: function (key, quantity) {
      this.content.style.opacity = '0.5';
      this.content.style.pointerEvents = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(() => this.refresh())
        .catch(err => console.error(err));
    },

    refresh: function (openAfter) {
      fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const newDrawer = html.querySelector('.cart-drawer');

          // Re-query in case DOM changed
          this.getElements();

          if (newDrawer && this.drawer) {
            this.drawer.innerHTML = newDrawer.innerHTML;
            this.content = document.getElementById('CartDrawerContent');
          }

          // Always update header cart count badge (outside the if block)
          this.updateHeaderCartCount();

          // Open drawer AFTER content is refreshed so user sees the added product
          if (openAfter) {
            this.getElements();
            this.open();
          }
        })
        .catch(e => {
          console.error('Cart drawer refresh error:', e);
          // Still update cart count even if drawer refresh failed
          this.updateHeaderCartCount();
          // Still try to open drawer even if refresh failed
          if (openAfter) {
            this.getElements();
            this.open();
          }
        })
        .finally(() => {
          this.getElements();
          if (this.content) {
            this.content.style.opacity = '1';
            this.content.style.pointerEvents = 'auto';
          }
        });
    },

    updateHeaderCartCount: function () {
      // Cache-bust to prevent stale CDN/browser cached responses
      fetch('/cart.js?t=' + Date.now())
        .then(res => res.json())
        .then(cart => {
          this.setCartCount(cart.item_count);
        })
        .catch(err => console.error('Cart count update error:', err));
    },

    // Direct count update without needing an extra fetch — used right after /cart/add.js
    setCartCount: function (count) {
      const cartCountEls = document.querySelectorAll('.cart-count');
      cartCountEls.forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }
  };

  // Initialize immediately since script is loaded at the end of the body
  window.CartDrawer.init();

  // Fetch the real cart count on first page load to fix stale cache / CDN issues
  window.CartDrawer.updateHeaderCartCount();

  // Global listener: any section that dispatches 'cart:updated' will refresh + open the drawer
  document.addEventListener('cart:updated', function () {
    if (window.CartDrawer) {
      window.CartDrawer.refresh(true);
    }
  });

    // Global listener: intercept standard product form submissions across the theme
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.action.includes('/cart/add') || form.querySelector('[name="id"]'))) {
      // If form doesn't handle its own AJAX (or is standard HTML form submit)
      if (!form.dataset.ajaxBound && !e.defaultPrevented) {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('.btn');
        const origText = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Adding...';
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(res => res.json())
        .then(() => {
          if (submitBtn) {
            submitBtn.innerHTML = '✓ Added!';
            setTimeout(() => {
              submitBtn.innerHTML = origText;
              submitBtn.disabled = false;
            }, 2000);
          }
          // Update cart count immediately (before drawer refresh)
          if (window.CartDrawer) {
            window.CartDrawer.updateHeaderCartCount();
            window.CartDrawer.refresh(true);
          }
        })
        .catch(err => {
          console.error(err);
          if (submitBtn) {
            submitBtn.innerHTML = origText;
            submitBtn.disabled = false;
          }
        });
      }
    }
  });


  /* ===================== ADD TO CART (AJAX) ===================== */
  window.addToCart = function (variantId, btn) {
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(() => {
        btn.textContent = '✓ Added!';
        btn.style.background = '#5a6e4e';

        // Update cart count immediately (before drawer refresh)
        if (window.CartDrawer) {
          window.CartDrawer.updateHeaderCartCount();
          window.CartDrawer.refresh(true);
        }

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.style.background = '';
        }, 2000);
      })
      .catch((err) => {
        console.error('Add to cart error:', err);
        btn.textContent = 'Error — try again';
        btn.style.background = '#c87941';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.style.background = '';
        }, 2500);
      });
  };

  /* ===================== SCROLL ANIMATIONS ===================== */
  const animatables = document.querySelectorAll(
    '.why-card, .product-card, .video-review-card, .benefit-item, .comp-item, .trust-item'
  );

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    animatables.forEach((el, i) => {
      el.style.transitionDelay = `${(i % 4) * 0.08}s`;
      el.setAttribute('data-animate', '');
      observer.observe(el);
    });
  } else {
    // Fallback: show all immediately
    animatables.forEach((el) => el.classList.add('in-view'));
  }

  /* ===================== NEWSLETTER FORM ===================== */
  const newsletterForm = document.getElementById('footer-newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      const emailInput = newsletterForm.querySelector('input[type="email"]');
      if (emailInput && !emailInput.validity.valid) {
        e.preventDefault();
        emailInput.focus();
      }
    });
  }

  /* ===================== QUOTE SLIDER ===================== */
  const quoteSlides = document.querySelectorAll('.quote-slide');
  const quoteDots = document.querySelectorAll('#quote-pagination-dots .dot');
  let currentQuoteIndex = 0;
  let quoteInterval;

  function showQuote(index) {
    if (!quoteSlides.length) return;

    quoteSlides.forEach(slide => slide.classList.remove('active'));
    quoteDots.forEach(dot => dot.classList.remove('active'));

    currentQuoteIndex = index;
    if (currentQuoteIndex >= quoteSlides.length) currentQuoteIndex = 0;
    if (currentQuoteIndex < 0) currentQuoteIndex = quoteSlides.length - 1;

    quoteSlides[currentQuoteIndex].classList.add('active');
    if (quoteDots[currentQuoteIndex]) {
      quoteDots[currentQuoteIndex].classList.add('active');
    }
  }

  function startQuoteSlider() {
    if (!quoteSlides.length || quoteSlides.length <= 1) return;
    quoteInterval = setInterval(() => {
      showQuote(currentQuoteIndex + 1);
    }, 5000);
  }

  quoteDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showQuote(index);
      clearInterval(quoteInterval);
      startQuoteSlider();
    });
  });

  startQuoteSlider();

  /* ===================== SMOOTH ANCHOR SCROLL ===================== */
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
